import { CloseOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { RemovePlaidTokenDocument } from '@willow/graphql-iso/src/portal';
import { Button } from '@willow/shared-web';

import { WillowModal } from '../modal/Modal';

import './DwollaResetMicrodepositModal.scss';

export const DwollaResetMicrodepositButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        type="button"
        className="dwolla-reset-open-modal-btn"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <div className="d-flex align-items-center">
          <CloseOutlined />
          Cancel verification
        </div>
      </button>
      <DwollaResetMicrodepositModal showModal={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

const DwollaResetMicrodepositModal = ({ showModal, onClose }: { showModal: boolean; onClose: () => void }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [removePlaidToken] = useMutation(RemovePlaidTokenDocument, {
    refetchQueries: ['getDwollaUser'],
  });

  const handleSubmit = useCallback(async () => {
    try {
      setIsSubmitting(true);
      await removePlaidToken();
      toast.success('Bank account successfully reset');
      onClose();
    } catch (_err: unknown) {
      toast.error('Failed to reset. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  }, [removePlaidToken, onClose]);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <WillowModal showModal={showModal} onClose={handleCancel}>
      <div className="dwolla-reset-microdeposit-modal">
        <h2>Cancel micro-deposit verification?</h2>
        <div className="dwolla-reset-microdeposit-modal__copy">
          Once canceled, you can attach a new bank account. Depending on your bank, you may be prompted to complete a
          new micro-deposit verification.
        </div>
        <div className="d-flex mt-3 justify-content-center gap-2">
          <Button variant="secondary" className="fw-normal" onClick={handleCancel} disabled={isSubmitting}>
            No, do not cancel
          </Button>
          <Button
            variant="primary"
            className="fw-normal"
            onClick={handleSubmit}
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            Yes, cancel verification
          </Button>
        </div>
      </div>
    </WillowModal>
  );
};
